
import { defineComponent, PropType, ref, Ref, nextTick } from "vue";

import { useService } from "use-vue-service";

import { TodoStatus, Todo, TodoService } from "@/services/todo.service";

export default defineComponent({
  props: {
    todo: {
      type: Object as PropType<Todo>,
      required: true
    }
  },
  setup(props) {
    const inputRef: Ref<HTMLInputElement | null> = ref(null);
    const editingStatus = ref(false);
    const editingValue = ref(props.todo.name);
    const todoService = useService(TodoService);
    const toggleStatus = async () => {
      editingStatus.value = !editingStatus.value;
      if (editingStatus.value) {
        await nextTick();
        inputRef.value?.focus();
      }
    };
    const updateTodo = () => {
      todoService.updateTodo(props.todo, editingValue.value);
      toggleStatus();
    };
    return {
      todoService,
      TodoStatus,
      editingValue,
      updateTodo,
      editingStatus,
      toggleStatus,
      inputRef
    };
  }
});
